var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.5M8 10V10.0067",
    stroke: "#D42015",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33338 12.6664H12.6667C12.8843 12.6648 13.0981 12.6101 13.2896 12.5069C13.4812 12.4038 13.6445 12.2553 13.7655 12.0745C13.8865 11.8937 13.9614 11.686 13.9837 11.4696C14.006 11.2532 13.975 11.0347 13.8934 10.833L9.16005 2.66635C9.04474 2.45795 8.87572 2.28424 8.67055 2.16328C8.46538 2.04231 8.23155 1.97852 7.99338 1.97852C7.75521 1.97852 7.52138 2.04231 7.31621 2.16328C7.11104 2.28424 6.94202 2.45795 6.82671 2.66635L2.09338 10.833C2.01334 11.0301 1.9816 11.2434 2.00081 11.4552C2.02002 11.667 2.08963 11.8712 2.20381 12.0506C2.318 12.2301 2.47345 12.3796 2.6572 12.4867C2.84094 12.5938 3.04764 12.6554 3.26005 12.6664",
    stroke: "#D42015",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlertIcon);
export default __webpack_public_path__ + "static/media/redAlertIcon.76c858f0fd1064810821cf192d2c91f3.svg";
export { ForwardRef as ReactComponent };